import React, { FC, useContext, useEffect } from "react"
import Reports from "../../components/client-payments/Reports"
import useScrollToTop from "../../hooks/useScrollToTop"
import { Button } from "../../components/ui/button"
import { CommonFunctionCtx } from "../../context/commonFunctionContext"
import { SvgNewWindow, SvgBilling, SvgWallet } from "../../components/icons/"
import { useNavigate } from "react-router-dom"

interface Props {}

const ClientPayments: FC<Props> = () => {
  const navigate = useNavigate()
  const { setPopupNotification, updateNextStepsData } =
    useContext(CommonFunctionCtx)
  const goToPaymentCenter = () => {
    navigate("/account-settings/payment-center")
  }

  const checkUrlParams = () => {
    const params = new URLSearchParams(window.location.search)
    const invalidOnboardingLink = params.get("invalid-link")
    const connectComplete = params.get("connect-complete")
    if (invalidOnboardingLink && invalidOnboardingLink === "true") {
      setPopupNotification({
        show: true,
        title: "Invalid Onboarding Link",
        message: "Try starting your onboarding again in a few minutes!",
        callback: null,
      })
    } else if (connectComplete && connectComplete === "true") {
      setTimeout(() => {
        updateNextStepsData(false).then(() => {})
      }, 4000)
    }
  }

  useScrollToTop()

  useEffect(() => {
    checkUrlParams()
  }, [])

  return (
    <div className="pt-[12px] md:pt-0 mx-auto md:max-w-[1112px] w-auto px-[16px] flex flex-col -mt-0 md:-mt-[33px]">
      <h1 className="mt-[24px] font-bold text-[36px]">Client Payments</h1>
      <div>
        <div className="flex flex-col md:flex-row justify-start md:justify-between items-start md:items-center w-full mt-[12px] md:mt-[50px] md:mb-[54px] gap-3 md:gap-0">
          <div
            className="flex items-center justify-start flex-wrap gap-[8px] text-graySlate 
      text-base font-bold w-full md:w-auto mb-[16px] md:mb-0"
          >
            <Button
              size="lg"
              onClick={goToPaymentCenter}
              className="z-10 sm:px-6 px-3"
              variant="outline"
            >
              <SvgWallet /> Payment Center
            </Button>

            <Button
              size="lg"
              onClick={goToPaymentCenter}
              className="z-10 relative sm:px-6 px-3"
              variant="disable"
              disabled
            >
              <SvgBilling /> Get Paid
            </Button>
          </div>

          <Button
            variant="outlineDynamic"
            size="lg"
            className="text-black border-black -mt-4 sm:-mt-0 mb-4 sm:mb-0"
            onClick={() =>
              window.open("https://www.paypal.com/signin?...", "_blank")
            }
          >
            <span>PayPal Dashboard</span> <SvgNewWindow />
          </Button>
        </div>
        <div>
          <Reports />
        </div>
      </div>
    </div>
  )
}

export default ClientPayments
